/**
 * @description 获取当前时间
 * @param format 时间格式
 * @returns 
 */
const getCurrentTime = (format: any) => {
    const now: any = new Date();
    const year: any = now.getFullYear(); // 得到年份
    let month: any = now.getMonth(); // 得到月份
    let date: any = now.getDate(); // 得到日期
    let hour: any = now.getHours(); // 得到小时
    let minu: any = now.getMinutes(); // 得到分钟
    let sec: any = now.getSeconds(); // 得到秒
    month = month + 1;
    if (month < 10) {
        month = "0" + month;
    }
    if (date < 10) {
        date = "0" + date;
    }
    if (hour < 10) {
        hour = "0" + hour;
    }
    if (minu < 10) {
        minu = "0" + minu;
    }
    if (sec < 10) {
        sec = "0" + sec;
    }
    let time = "";
    if (format == "yyyy") {
        time = year
    } else if (format == "yyyy-MM") {
        time = year + "-" + month
    } else if (format == "yyyy-MM-dd") {
        time = year + "-" + month + "-" + date
    } else if (format == "yyyy-MM-dd HH") {
        time = year + "-" + month + "-" + date + " " + hour
    } else if (format == "yyyy-MM-dd HH:mm") {
        time = year + "-" + month + "-" + date + " " + hour + ":" + minu
    } else if (format == "yyyy-MM-dd HH:mm:ss") {
        time = year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
    }
    return time;
}
/**
 * @description 树结构格式化，把打平的直接处理成嵌套的格式
 * @param data 需要处理的数据,打平的数据
 * @param idKey 唯一识别字段，不传就是id
 * @param parentKey 父结构字段，不传就是parent
 * @param childrenKey 子集字段，不传就是children
 * @returns 
 */
const BuildTree = (data: any, idKey: any = "id", parentKey: any = "parent", childrenKey: any = 'children') => {
    // 创建一个map，以id为键，以对应的对象为值  
    let map: any = {};
    data.forEach((item: any) => {
        map[item[idKey]] = { ...item };
        map[item[idKey]][childrenKey] = [];
        map[item[idKey]].level = 1;
    });

    // 递归函数，用于构建树形结构并设置level字段  
    function buildTreeRecursive(parentId: any, level: any) {
        let tree: any = [];
        data.forEach((item: any) => {
            if (item[parentKey] === parentId) {
                const newNode = { ...map[item[idKey]], level: level }; // 设置当前节点的level  
                newNode[childrenKey] = buildTreeRecursive(item[idKey], level + 1); // 递归构建子节点  
                tree.push(newNode);
            }
        });
        return tree;
    }
    // 构建树的根节点，level为0  
    const tree = buildTreeRecursive(null, 1);
    return tree;
}
/**
 * @description 把obj数组处理成str数组
 * @param data 需要处理的数据
 * @param idKey 需要提取的字段字段，不传就是id,
 * @param filterKey 需要过滤的字段
 * @param filterKValue 需要过滤的值
 * @returns 
 */
const GetIdArr = (data: any, idKey: any = "id", filterKey?: any, filterValue?: any) => {
    let arr: any = [];
    if (data.length > 0) {
        data.forEach((item: any) => {
            if (filterKey) {
                if (item[filterKey] == filterValue) {
                    arr.push(item[idKey])
                }

            } else {
                arr.push(item[idKey])
            }

        });
    }

    return arr;
}
/**
 * @description 树结构格式化，把打平的直接处理成嵌套的格式
 * @param data 需要处理的数据,打平的数据
 * @param filterKey 需要过滤的字段
 * @param filterKValue 需要过滤的值
 * @returns 
 */
const GetObjArr = (data: any, filterKey?: any, filterValue?: any) => {
    let arr: any = [];
    if (data.length > 0) {
        data.forEach((item: any) => {
            if (item[filterKey] == filterValue) {
                arr.push(item)
            }
        });
    }

    return arr;
}
/**
 * @description 根据中文名字找英文字段
 * @param name 中文名称
 * @returns 
 */
const GetKey = (name: any) => {
    let key: any = '';
    switch (name) {
        case '疾病诊断':
            key = 'disease_diagnosis'
            break;
        case '既往史':
            key = 'past_history'
            break;
        case '过敏史':
            key = 'allergy_history'
            break;
        case '用药史':
            key = 'drug_history'
            break;
        case '家族史':
            key = 'family_history'
            break;
        case '心血管病史':
            key = 'heart_disease_history'
            break;
        case '生活方式':
            key = 'lifestyle'
            break;

        default:
            break;
    }
    return key;
}
/**
 * @description 清除filter
 * @param data{}
 * @returns 
 */
const clearFilter = () => {
    localStorage.setItem("articleListFilter", "");
    localStorage.setItem("kepuListFilter", "");
    localStorage.setItem("feedbackFilter", "");
    localStorage.setItem("literatureFilter", "");
    localStorage.setItem("literatureFolderFilter", "");
}
export {
    getCurrentTime, clearFilter, BuildTree, GetIdArr, GetObjArr, GetKey
};